export const CURRENCY_FORMAT = "$";
export const INDIAN_CURRENCY = "₹";
export const ZERO = "0";
export const ZERO_NUMBER = 0;
export const NUMBER_ONE = 1;
export const SKELETON_ROWS_10 = 10;
export const ENTER_KEY = "Enter";
export const PERCENTAGE = "%";
export const PLUS_SIGN = "+";
export const NEGATIVE_SIGN = "-";
export const HTTP_STATUS_SUCCESS = "SUCCESS";
export const COPYRIGHT = "©";
export const FILE_SIZE_LIMIT = 5000000;
export const dMMMyyyy = "d-MMM-yyyy";
export const ddMMMyyyy = "dd-MMM-yyyy";
export const ddmmyyyy = "dd-mm-yyyy";
export const yyyyMMMd = "yyyy-MMM-d";
export const DD_MMM_YYYY = "DD-MMM-YYYY";
export const YYYYMMDD = "YYYY-MM-DD";
export const DAY = "day";
export const yyyyMMdd = "yyyy-MM-dd";
export const dd_MMM_yyyy = "dd MMM, yyyy";
export const yyyymmdd = "yyyy-mm-dd";
export const MMMYY = "MMM-YY";

export const FT_CODE = "FT";
export const COUNTRY_CODE_AU = "AU";
export const COUNTRY_CODE_NZ = "NZ";
export const SEARCH_TYPE_NAME = "NAME";
export const SEARCH_TYPE_ADDRESS = "ADDRESS";
export const INVOICE_STATUS_VOIDED = "VOIDED";
// Alert token raised by the daily Xero sweep: the debtor has settled the invoice
// in the customer's Xero while FundTap is still owed. Must match
// QuoteCalculationProcess.PAID_NOT_REPAID_ALERT in loan-management-service.
export const ALERT_PAID_NOT_REPAID = "PAID NOT REPAID";
export const EXPORT_TYPE_ON_SCREEN = "on_screen";
export const EXPORT_TYPE_PDF = "pdf";
export const EXPORT_TYPE_EXCEL = "excel";
export const FEE_DATE_DATA = "Fee as at [Date]";
export const STATUS_1 = "1";
export const STATUS_2 = "2";
export const STATUS_3 = "3";
export const STATUS_4 = "4";
export const STATUS_5 = "5";
export const STATUS_7 = "7";
export const STATUS_9 = "9";
export const STATUS_11 = "11";
export const STATUS_12 = "12";
export const STATUS_13 = "13";

// Quote statuses (Funded, Completed) whose funded amount is guarded: the advance has
// already been paid out, so the change is confirmed before it is sent.
export const GUARDED_FUNDED_AMOUNT_STATUS_IDS = [4, 9];

export const STANDARD = "Standard";
export const VARIABLE = "Variable";
export const ISTRUE = "true";
export const COMMERCIAL = "COMMERCIAL";
export const FINANCIAL = "FINANCIAL";
export const CONSUMER = "CONSUMER";
export const TRUST_CORPORATE = "TRUST_CORPORATE";
export const CORPORATE_TRUST_ASSOCIATE = "CORPORATE_TRUST_ASSOCIATE";
export const TRUST = "Trust";
export const CORPORATE = "Corporate";
// Shape of a corporate_trust_associates row: the role it holds on the trust or
// corporate, and whether that role is filled by a person or a company.
export const ROLE_TYPE_DIRECTOR = "DIRECTOR";
export const ENTITY_TYPE_COMPANY = "COMPANY";
export const USER = "USER";
export const MANUAL = "Manual";
export const ACN = "ACN";
export const ABN = "ABN";
export const MONTH = "month";
export const MONTH_LABEL = "Month";
export const QUARTER = "quarter";
export const YEAR = "year";
export const WEEK = "Week";
export const LENDING = "lending";
export const STATUS12 = "12";
export const BNR = "bnr";
export const GOCARDLESS = "GoCardless";
export const PARTIAL = "PARTIAL";
export const UNMATCHED = "UNMATCHED";
export const COMPLETE = "COMPLETE";
export const COMPLETED = "Completed";
export const FUNDED = "Funded";
export const ANNATURE_STATUS_COMPLETED = "completed";
export const SUCCESS = "Success";
export const PENDING = "Pending";
export const FAILED = "Failed";
export const OWNERS_ADVERSE = "Adverse";
export const OWNERS_CREDIT = `Credit Score`;
export const STATE_NT = "NT";
export const STATE_ACT = "ACT";
export const STATE_TAS = "TAS";
export const PERSONAL = "Personal";
export const ADDRESS_TYPE_PERSONAL = "PERSONAL";
export const FUNDINGNOTICE = "fundingNotice";
export const REPAYMENTDATE = "repaymentDate";
export const DUEDATE = "dueDate";
export const INVOICEDATE = "invoiceDate";
export const TOTALAMOUNT = "totalAmount";
export const NOTAPPROVED = "Not Approved";
export const APPROVED = "Approved";
export const CUSTOMER_DD = "Customer DD";
export const OTHER = "Other";
export const CUSTNOTREQUIRE = "Cust Not Require";
export const CUSTOMER = "Customer";
export const UNKNOWN = "Unknown";
export const SALSEPERLEADID = "salesPersonLeadId";
export const FALSE = "false";
export const TRUE = "true";
export const ACTIVE = "active";
export const INACTIVE = "inactive";
export const DELETED = "deleted";
export const STATIC = "static";
// Sent as the `quoteStatus` request parameter on /loan-mgmt/quote/quotes-by-user.
// Spring binds it to QuoteSearchFilterEnum by exact constant name, so the
// capitalisation is load-bearing: any other casing fails to bind and the request
// 500s before it reaches the controller.
export const ALL = "ALL";
export const MONTHLY_LENDING_VIEW_CUMULATIVE = "cumulative";
export const MONTHLY_LENDING_VIEW_PER_DAY = "perDay";
export const FULFILLED = "fulfilled";
export const PROCESSING = "PROCESSING";
export const CUSTOMERTYPE = "user";
export const INVOICE = "invoice";
export const REFERRAL = "referral";
export const NA = "NA";
export const N_A = "N/A";
export const MONTH_12 = "12";
export const MONTH_11 = 11;
export const DAY_31 = 31;
export const CURRENT_YEAR = "CURRENT YEAR";
export const PREVIOUS_YEAR = "PREVIOUS YEAR";
export const CURRENT = "current";

export const showToastType = {
  success: "success",
  error: "error",
  info: "info",
  text: "SMS template is paused. Please activate template and try again.",
  errorText: "Something went wrong",
  commentDelete: "Comment deleted successfully"
};

export const RECAPTCHA_ERROR = "reCAPTCHA error";
export const EXPIRY_ERROR = "reCAPTCHA error";
// The tag auth-service puts in `errors[0]` on a 400 from /auth/login. It is an
// internal label, not copy — never render it.
export const RECAPTCHA_ERROR_TAG = "ReCAPTCHA Error";
export const DISCHARGED = "DISCHARGED";
export const NOTREGISTERED = "NOT REGISTERED";
export const PROPERTY_TYPE = "Other Property";
export const NOTCONNECTED = "Not connected";
export const YES = "yes";
export const CUSTOMERS = "customers";
export const ADDRESSFINDERKEY = "6RH7MEWTP8LN4C3XGYB9";
export const NAME_REGEX = /^[A-Za-z\s\-']+$/;
// A person's legal name as it goes on the account: letters in any script, plus the spaces, hyphens,
// apostrophes and full stops real names carry — "Anne-Marie", "O'Brien", "Te Ariki", "Tāne", "J. Smith".
// These names reach Centrix on a credit enquiry and Annature on a deed, so anything this rejects is a
// name that cannot be recorded correctly. Combining marks (\p{M}) are accepted after the first letter:
// a pasted or IME-produced name can arrive decomposed (Ta + U+0304 rather than "Tā"), and scripts such
// as Devanagari carry matras as marks in any form. Pair this with normalizeLegalName so what is stored
// is one consistent form.
export const LEGAL_NAME_REGEX = /^\p{L}[\p{L}\p{M}\s'’.-]*$/u;

export const NAME_PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&?.])[A-Za-z\d#$@!%&?.]{8,}$/;
export const EMAIL_REGEX = /\S+@\S+\.\S+/;
export const EMAIL_REGEX_STRICT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const NAME_REGEX_OPTIONAL = /^[a-zA-Z\s]*$/;
export const PHONE_REGEX = /^\+?\d+$/;
export const PHONE_REGEX_STRICT = /^\+?[0-9]+$/;
export const LETTERS_REGEX_STRICT = /^[A-Za-z\s'-]+$/;

export const COMMISSION_RATE_REGEX = /^\d+(\.\d{1,2})?$/;
export const USERNAME_REGEX = /^[A-Za-z0-9@_-]+$/;
export const NAME_REGEX_STRICT = /^[a-zA-Z]{2,}$/;
export const ABN_REGEX_STRICT = /^\d{11}$/;
export const NZBN_REGEX_STRICT = /^\d{13}$/;
export const NUMBER_REGEX = /^\d+$/;
export const DIGIT_REGEX = /\d/;
export const NON_DIGIT_REGEX = /\D/;
export const UPPERCASE_REGEX = /[A-Z]/;
export const LOWERCASE_REGEX = /[a-z]/;
export const ESCAPE_REGEX = /\W/;

export const PASSWORD_VALIDATION_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
export const SPECIAL_CHAR_REGEX = /[^A-Za-z0-9]/;
export const FT_OR_NUMBER_REGEX = /^(FT\d+|\d+)$/i;
export const AU_PHONE_REGEX = /^61[0]/;
export const WHITESPACE_REGEX = /\s+/g;
export const PHONE_CLEANUP_REGEX = /[()\-\s]/;

export const EMAIL_REGEX_SIMPLE =
  /^[^!\s@]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
export const NZ_PHONE_REGEX = /^64[0]/;

export const UUID_REGEX =
  /^[^\-\s]{8}-[^\-\s]{4}-[^\-\s]{4}-[^\-\s]{4}-[^\-\s]{12}$/;

export const DASH_LOWERCASE_REGEX = /-([a-z])/g;

export const ALPHABETIC_REGEX = /^[a-zA-Z]*$/;

export const NON_NUMERIC_REGEX = /[^0-9.-]+/g;

export const METHOD_FORMAT_REGEX = /[^a-zA-Z]/g;

export const ENDPOINT_FORMAT_REGEX = /[^a-z0-9/_-]/g;

export const REGEX_POSTCODE_4 = /^\d{4}$/;

export const AREA_CODES = {
  au: ["61"],
  nz: ["64"]
};

export const COUNTRY_CODE_AU_SMALL = "au";
export const COUNTRY_CODE_NZ_SMALL = "nz";
export const MAX_CALL_COUNT = 3;
export const ZEROSTRING = "0.00";
export const XERO = "Xero";
export const RECKON = "Reckon";
export const MYOB = "MYOB";
export const QUICKBOOKS = "QuickBooks";
export const MAILTO_INFO_EMAIL = "mailto:info@fundtap.co";
export const INFO_EMAIL = "info@fundtap.co";
export const COMPANY_EMAIL = "info@fundtap.co.nz";
export const MAILTO_COMPANY_EMAIL = "mailto:info@fundtap.co.nz";
export const CONNECTED = "CONNECTED";
export const DISCONNECTED = "DISCONNECTED";
export const PHONE_NO_AU = "tel:1800595505";
export const PHONE_NO_NZ = "tel:0800883355";
export const CALL_NO_AU = "1800 595 505";
export const CALL_NO_NZ = "0800 88 33 55";
export const MODAL = "modal";
export const REDIRECT = "redirect";
export const QUICKBOOKLOGO_WIDTH = "446";
export const QUICKBOOKLOGO_HEIGHT = "72";
export const MYOBLOGO_WIDTH = "303";
export const ACCOUNTINGSOFTLOGO_SIZE = "200";
export const FUNCTION = "function";
export const CUSTOMERDETAILS = "customerDetails";
export const NAME = "name";
export const REFERRALDETAILS = "referralDetails";
export const FULLNAME = "fullName";
export const INVOICE_DETAILS = "Invoice details";
export const NO = "No";
export const VIEW_OPTIONS_TYPE = {
  YEAR: "Year",
  QUARTER: "Quarter",
  MONTH: "Month"
};

export const AI_TRAINING_DATA = "AI_TRAINING_DATA";
export const DOWNLOAD_INVOICE = "DOWNLOAD_INVOICE";
export const FT_CREDIT_SCORE_DATA = "FT_CREDIT_SCORE_DATA";
export const PROCESSING_STATUS = "PROCESSING";
export const PENDING_STATUS = "PENDING";
export const INVOICE_COLUMN_COUNT = 10;
export const USER_STATUS_PENDING = 1;
export const USER_STATUS_APPROVED = 2;
export const USER_STATUS_NOT_APPROVED = 3;
export const USER_STATUS_ARCHIVED = 7;
export const USER_STATUS_PRE_APPROVED = 9;
export const MONTH_2 = "2";
export const LOWEST_VALUE = "LOWEST_VALUE";
export const EMAIL = "Email";
export const INFO = "Info";
export const CREDIT_COMMENT_TYPE = "Com_Credit";
export const FINANCIAL_CREDIT = "Financial_Credit";
export const OWNER_CREDIT = "Owner_Credit";
export const CORPORATE_CREDIT = "Corporate_Credit";
export const SECONDARY_OWNER_CREDIT = "Secondary_Owner_Credit";
export const COLUMN_COUNT_12 = 12;
export const PASSPORT = "Passport";
export const FMFB_TO_FR = "FMFB_TO_FR";
export const FMFB_FR = "FMFB-FR";
export const FR_TO_FMFB = "FR_TO_FMFB";
export const STATUS = "STATUS";
export const STATUS_KEY = "status";
export const DELTA = "DELTA";
export const FR_FMFB = "FR-FMFB";
export const DAYS_BACK = 14;
export const MODAL_HEIGHT = "60px";
export const MODAL_WIDTH = "31px";
export const PAGE_SIZE = 10;
export const PAGE_SIZE_25 = 25;
export const PAGE_SIZE_50 = 50;
export const REPORT_PAGE_SIZE = 200;
export const PAGE_INDEX = 0;
export const INITIATED = "Initiated";
export const MISSING_ACCESS_TOKEN_COOKIE = "Missing access token cookie";
export const ORGANIZATIONNAME = "organizationName";
export const DOCUMENT_TYPE_GUARANTEE = "Guarantee";
export const DOCUMENT_TYPE_TRUST_GUARANTEE = "Trust_Guarantee";
export const DOCUMENT_TYPE_CORPORATE_GUARANTEE = "Corporate_Guarantee";
export const DOCUMENT_TYPE_DIRECTORS_RESOLUTION = "Directors_Resolution";
// Selecting this in the owner Agreement dropdown generates the demand letter pack rather than
// choosing a document to email or upload.
export const DOCUMENT_TYPE_DEMAND_LETTERS = "DEMAND_LETTERS";
export const DEMAND_LETTER_MIN_DAYS_UNTIL_DUE = 1;
export const DEMAND_LETTER_MAX_DAYS_UNTIL_DUE = 365;
export const POP = "POP";
export const NZPATTERN = /^\+64[0-9]{8,9}$/;
export const AUPATTERN = /^\+61[0-9]{8,9}$/;
// An NZ or AU number, 10 to 13 digits including the country code - the same
// numbers signing up takes. Anything narrower refuses a number the account was
// opened with, which is what a director or shareholder row is pre-filled from.
export const PRIMARY_CONTACT_NUMBER_REGEX = /^\+(61|64)\d{8,11}$/;
export const PRIMARY_CONTACT_NUMBER_MAX_LENGTH_AU = 15;
export const PRIMARY_CONTACT_NUMBER_MAX_LENGTH_NZ = 17;
export const QATREDIRECTURL = "http://13.202.118.250:82/";
export const PRODREDIRECTURL = "http://13.54.224.182:82/";
export const SCHEDULED_SECOND_FIVE = 5000;
export const SCHEDULED_SECOND_TEN = 5000;
export const YES_CAPS = "Yes";
export const INITIAL_VALUE_ZERO = "0.00";
export const MAX_COMMENT_LENGTH = 500;
export const EXP_AU_YEAR_PERIOD = 7;
export const EXP_NZ_YEAR_PERIOD = 5;
export const COLUMN_COUNT_2 = "2";
export const MIN_LOGS_TO_SHOW = 2;
export const MIN_DIRECTORS = 3;
export const MAX_DIRECTORS = 9;
export const LENGTH_0 = 0;
export const LENGTH_1 = 1;
export const POSTAL_CODE_REQUIRED_LENGTH = 4;
export const EMPTY_LENGTH = 0;
export const AU_PROPERTYURL = "https://www.onthehouse.com.au/";
export const NZ_PROPERTYURL = "https://propertyguru.corelogic.co.nz/";
export const ADMIN_ADD_TOKEN = "Admin Add";
export const MAX_INITIAL_FUNDS_LIMIT = 300000;
export const FUNDTAPAUURL = "https://fundtap.co/au/";
export const FUNDTAPURL = "https://fundtap.co";
const getFrontendOrigin = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://secure.fundtap.co";
};
export const EMAIL_LOGO_URL = `${getFrontendOrigin()}/fundtap-logo.png`;
export const FUNDTAP_FEATURES_URL = "https://fundtap.co/features/";
export const FUNDTAP_PARTNER_URL = "https://fundtap.co/partners/";
export const FUNDTAP_LATEST_ARTICLE_URL =
  "https://fundtap.co/resources/#latest-article";
export const FUNDTAP_POPULER_ARTICLE_URL =
  "https://fundtap.co/resources/#populer-article";
export const FUNDTAP_ABOUT_US_URL = "https://fundtap.co/about-us/";
export const FUNDTAP_CONTACT_URL = "https://fundtap.co/contact/";
export const FUNDTAP_PRIVACY_POLICY_URL = "https://fundtap.co/privacy-policy/";
export const PROPERTY_OWNERSHIP_OTHER_PROPERTY = "No-but I own other Property";
export const PROPERTY_OWNERSHIP_CHOOSE = "Choose";
export const ANNATURE_ENVELOPES_REDIRECT_URL =
  "https://dashboard.annature.com.au/envelopes/";
export const START = "Start";
export const INPROGRESS = "In progress";
export const WAITING_START = "Waiting to start";
export const COUNTER_1 = "1";
export const COUNTER_2 = "2";
export const COUNTER_3 = "3";
export const EXAMPLE_CONTACT_NUMBER = "21 123 4567";
export const SHARE_HOLDER_PERCENT_STEP = "25.00";
export const GOCARDLESS_SETUP_COMPLETE_MESSAGE = "gocardless-setup-complete";
export const GOCARDLESS_SETUP_EXIT_MESSAGE = "gocardless-setup-exit";
export const EXCLAMATION = "!";
export const ALLOWED_FILE_TYPES = ".pdf,.jpg,.jpeg,.png,.heic";
export const HUBSPOT_PORTAL_ID = process.env.REACT_APP_HUBSPOT_PORTAL_ID;
export const HUBSPOT_URL = "https://app-ap1.hubspot.com...";
export const CONTACT_SUPPORT = "CONTACT_SUPPORT";
export const CONTACT_SUPPORT_LINK =
  "https://fundtap.co/contact/#:~:text=Send-,Contact%20Details,-Any%20questions%2C%20don%E2%80%99t";
export const LINK_REL = "noopener noreferrer";
("https://dashboard.annature.com.au/envelopes/");
export const NZ_BANK_ACC_NO = "02-0192-0532860-00";
export const AU_BANK_ACC_NO = "013011-3200-51325";
export const API_ERROR_400 = 400;
export const RECIPIENT_TYPE_USER = "User";
export const FUNDED_STATUS_ID = 4;
export const MAX_DAY_COUNT = 30;
export const TOTAL_USERS = "totalUsers";
export const INVOICE_NUMBER = "invoiceNumber";
export const ICON_URL = "iconUrl";
export const IS_SUPPORTED = "isSupported";
export const REFERRAL_USER_LENGTH_0 = 0;
export const REFERRAL_USER_LENGTH_1 = 1;

export const DEV_BASE_URL = process.env.REACT_APP_DEV_BASE_URL;
export const DEV_WPSIGNUP_URL = process.env.REACT_APP_DEV_WPSIGNUP_URL;

export const QA_BASE_URL = process.env.REACT_APP_QA_BASE_URL;
export const QA_WPSIGNUP_URL = process.env.REACT_APP_QA_WPSIGNUP_URL;

export const PROD_BASE_URL = process.env.REACT_APP_PROD_BASE_URL;
export const PROD_WPSIGNUP_URL = process.env.REACT_APP_PROD_WPSIGNUP_URL;

export const STAGE_BASE_URL = process.env.REACT_APP_STAGE_BASE_URL;
export const STAGE_WPSIGNUP_URL = process.env.REACT_APP_STAGE_WPSIGNUP_URL;
export const PREVENT_BUTTON_CLICK = 2000;
export const IP_API_URL = "https://ipapi.co/json/";

export const SYNC_POLLING_INTERVAL = 20000; // 20 seconds
export const APPLY_ID_STATUS_POLL_INTERVAL = 10000; // 10 seconds
export const GOCARDLESS_STATUS_POLL_INTERVAL = 10000; // 10 seconds

// Gap between the two attempts at a GoCardless billing request. Long enough
// for a brief outage to pass, short enough that the customer keeps waiting.
export const GOCARDLESS_RETRY_DELAY = 1500; // 1.5 seconds
export const JOB_QUEUE_HEALTH_POLL_INTERVAL = 15000; // 15 seconds
// Ceiling for the exponential backoff applied on repeated fetch failures
// (15s -> 30s -> 60s -> 120s, then holds here) so a backend outage doesn't
// get hammered every 15s indefinitely.
export const JOB_QUEUE_HEALTH_MAX_POLL_INTERVAL = 120000; // 2 minutes
export const VISIBILITY_CHANGE_EVENT = "visibilitychange";
export const REPORT_PAGE_SIZE_OPTIONS = [10, 25, 50, 200];
export const PAGE_SIZE_OPTIONS = [10, 25, 50];
export const DASHBOARD_MENU = "Dashboard";
export const DASHBOARD_MENU_ID = 7;
export const PAGE_COUNT = 1;

export const PROD_ENV = "prod";
export const STAGING_ENV = "staging";
export const APPROVED_CUSTOMERS = "approved-customers";
export const FORCE_APPLICATION_PROCESS = "forceApplicationProcess";
export const PAGE_NAVIGATE_0 = 0;
export const ASC = "asc";
export const DESC = "desc";
export const COMMENT_PREFIX = "CC:";
export const STORAGE_RESET_KEY = "idle-timeout-reset";
export const STORAGE_LOGOUT_KEY = "idle-timeout-logout";
export const ALLOWED_KEYS = [
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Tab",
  "Home",
  "End"
];
export const PH_LENGTH_9 = 9;
export const PH_LENGTH_11 = 11;
export const PH_LENGTH_12 = 12;
export const PH_LENGTH_13 = 13;
export const SINGLE_DIGIT_REGEX = /^\d$/;
export const TRACK_CUSTOM = "trackCustom";
export const TRACK = "track";
export const REMOVE_COMMA_REGEX = /,/g;
export const CURRENCY_CLEANUP_REGEX = /[^0-9.-]/g;
export const REMOVE_NON_DIGIT_REGEX = /\D/g;
export const ACCEPTEDCREDITCONSENT = "ACCEPTEDCREDITCONSENT";
export const USERS_ROLE = {
  OWNER_OR_DIRECTOR: "Owner or Director",
  EMPLOYEE: "Employee",
  EXTERNAL_ADVISOR: "External Advisor"
};
export const PROPERTY_OWNED = {
  PERSONALLY_OWNED: "Personally Owned",
  OWNED_BY_TRUST: "Owned by a Trust",
  OWNED_BY_COMPANY: "Owned by a Company"
};
// Which onboarding section created a secondary user. Each section reads back the
// people it tagged, so the sections never show each other's.
export const SECONDARY_USER_TYPE = {
  PROPERTY_OWNER: "PROPERTY_OWNER",
  ACCOUNT_USER: "ACCOUNT_USER"
};
export const TRUST_TYPE = {
  PROPERTY_TRUST: "PROPERTY_TRUST",
  CORPORATE_TRUST: "CORPORATE_TRUST",
  TRADING_TRUST: "TRADING_TRUST",
  SHAREHOLDER_TRUST: "SHAREHOLDER_TRUST"
};

export const SUBMITTED_DIRECT_DEBIT = "SUBMITTED - Direct Debit";
export const SUBMITTED = "submitted";
export const accountData = {
  liabilityAccountName: "liabilityAccountName",
  liabilitySelect: "liabilitySelect",
  expenseAccountName: "expenseAccountName",
  expanceSelect: "expanceSelect",
  activeLiability: "activeLiability",
  activeFees: "activeFees",
  defaultFeesCode: "FT01",
  defaultFeesName: "FundTap Fees",
  defaultAdvanceCode: "FT02",
  defaultAdvanceName: "FundTap Advances"
};
export const USERSTATUSIDS = {
  OTHERS: 21,
  CUSTOMER_DD: 13
};
// Statement quoteType sent by the customer-facing Generate Statement page: every
// invoice dated in the range, whether it has money outstanding or is fully repaid.
// The admin "Time Period" export sends the same type, and both read
// QuoteRepo.findByLegalNameAndInvoiceDate, so both list the same rows: an advance
// with a funding date recorded against it.
// The fee figures differ. The customer endpoint prices fees at the range's end
// date (QuoteController.generateStatement passes endDate as the fee date), and the
// admin modal defaults its Fee Date to today (CustomerStatementModal.jsx). Over a
// historical range the fees match only when an operator sets that Fee Date to the
// range end.
export const STATEMENT_TIME_PERIOD = "time_period";
export const SYDNEY_TIMEZONE = "Australia/Sydney";

// reCAPTCHA v3 site key. Public — CRA inlines it into the bundle, and the
// browser sends it to Google, so it is not a secret. It is per-environment
// because v3 keys are domain-restricted: the key has to list the hostname the
// app is served from, or reCAPTCHA renders "Invalid domain for site key" and
// the login request carries no token. An environment whose dotenv file omits
// REACT_APP_RECAPTCHA_SITE_KEY_V3 falls back to the key registered for the
// fundtap.co hosts. Whichever key an environment ships, auth-service must hold
// the secret paired with it in app.recaptcha.secret-key-version-three.
export const GOOGLE_CAPTCHA_SITE_KEY_V3 =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY_V3 ||
  "6LdrJjAqAAAAAIi-Ng8OqkmA7koqglWO6j2qwlnM";

export const PPSR_TRUST_TYPE_CHECK = "trust_type_check";
export const PPSR_CORPORATE_TYPE_CHECK = "corporate_type_check";

export const SUBMISSION_DAYS_LENGTH = 3;
export const MIN_INVOICE_THRESHOLD = 300;

export const EXCEL_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const AGREEMENT_DELAY = "AGREEMENT_DELAY";
export const DISALLOWED_FILE_EXTENSIONS = ["xls", "xlsx", "csv", "doc", "docx"];
export const DOCUMENT_TYPE_TRUST_DEED = "trust_deed";
export const DOCUMENT_TYPE_TRUST_AMENDMENT = "trust_amendment";
export const DOCUMENT_TYPE_PROPERTY_TRUST_DEED = "property_trust_deed";
export const DOCUMENT_TYPE_PROPERTY_TRUST_AMENDMENT =
  "property_trust_amendment";
export const DOCUMENT_TYPE_MORTGAGE = "mortgage_statement";
// Supporting-document type display value (DocumentTypeEnum.BANK_STATEMENTS).
export const DOCUMENT_TYPE_BANK_STATEMENTS = "Bank Statements";
export const TRUST_DEED_ACCEPT = ".pdf";
export const MORTGAGE_FILE_ACCEPT = ".pdf,.jpg,.jpeg,.png,.heic";
export const REPAYMENT_CUTOFF_HOUR = 11;
export const DEFAULT_REPAYMENT_DATE_EXTENSION_DAYS = 5;
export const EXTENDED_REPAYMENT_DATE_EXTENSION_DAYS = 10;
// Accounting-software statuses (InvoiceDto.externalInvoiceStatus on the
// quotes-by-user response) that close the invoice at the source, so its
// repayment date can no longer be moved. Compared upper-cased because the
// value is passed through from the accounting software verbatim.
export const REPAY_DATE_BLOCKED_EXTERNAL_INVOICE_STATUSES = [
  "PAID",
  "DELETED",
  "VOID",
  "VOIDED"
];
export const TRUSTEE = "Trustee";
export const DIRECTORS = "Directors";
export const SHAREHOLDERS = "Shareholders";
export const USERS = "Users";

export const BUSINESS_TYPE_NOT_SURE = "Not Sure";
export const BUSINESS_TYPE_LIMITED_COMPANY = "Limited Company";
export const BUSINESS_TYPE_SOLE_TRADER = "Sole Trader";
export const BUSINESS_TYPE_PARTNERSHIP = "Partnership";
export const BUSINESS_TYPE_LIMITED_LIABILITY_PARTNERSHIP =
  "Limited Liability Partnership";
export const BUSINESS_TYPE_TRADING_TRUST = "Trading Trust";
export const FACILITY_SIZE_100_250 = "100-250";
export const FACILITY_SIZE_ABOVE_250 = "above-250";
export const TRUST_HELD = "TRUSTHELD";
export const COMPANY_HELD = "COMPANYHELD";
export const PERSONALLY_HELD = "PERSONALLYHELD";

export const BANK_CODE_LENGTH = 2;
export const BRANCH_CODE_LENGTH = 4;
export const AU_BRANCH_CODE_LENGTH = 6;
export const SUFFIX_LENGTH = 3;
export const SUFFIX_MIN_LENGTH = 2;
export const NZ_ACCOUNT_NUMBER_LENGTH = 7;
export const AU_ACCOUNT_NUMBER_MIN_LENGTH = 5;
export const AU_ACCOUNT_NUMBER_MAX_LENGTH = 9;
export const ACCOUNT_NUMBER_LENGTH = 15;
export const MAX_TRUSTEES = 3;
export const MAX_NAME_LENGTH = 15;
export const PRIMARY_CONTACT_COUNTRY_PREFIXES = [
  "+64",
  "+61",
  "0064",
  "0061",
  "64",
  "61"
];

export const OTP_CODE_LENGTH = 6;
export const SIGNUP_OTP_ERROR_ID = "signup-otp-code-error";
export const EDITOR_FONT_SIZES = [
  "8pt",
  "10pt",
  "12pt",
  "14pt",
  "18pt",
  "24pt",
  "36pt"
];
export const EDITOR_DEFAULT_TEXT_COLOR = "#0f172a";
export const EDITOR_DEFAULT_HIGHLIGHT_COLOR = "#ffff00";
export const EDITOR_HEX_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;
export const EDITOR_INDENT_STEP = 40;
export const EDITOR_MAX_INDENT = 200;
export const EDITOR_INDENTABLE_NODES = ["paragraph", "heading"];
export const EDITOR_LIST_ITEM_NODE_TYPE = "listItem";
export const EDITOR_SINK_LIST_ITEM_COMMAND = "sinkListItem";
export const EDITOR_LIFT_LIST_ITEM_COMMAND = "liftListItem";
export const CREDIT_DECISION_NOTES_SECTION = "CREDIT_DECISION_NOTES";
